import { makeStyles } from '@material-ui/core/styles';
import colors from '../../theme/colors';

export default makeStyles((theme) => ({
  cursorDefault: {
    color     : colors.SECONDARY_TEXT,
    cursor    : 'default',
    fontWeight: 'bold',
    wordBreak : 'break-word'
  },
  cursorPointer: {
    cursor    : 'pointer',
  },
  breadcrumbs: {
    fontSize    : '12px',
    display     : 'flex',
    marginBottom: theme.spacing(.5),
    '& .MuiBreadcrumbs-ol': {
      alignItems: 'center',
      flexWrap  : 'nowrap'
    },
    '& .MuiBreadcrumbs-li': {
      display: 'flex'
    }
  },
  titleContainer: {
    alignItems: 'center',
    display   : 'flex',
    height: theme.spacing(5),
    '& .MuiTypography-root': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    }
  },
  titleBox: {
    alignSelf : 'center',
    width: '80%'
  },
}));